import React from 'react';
import { connect } from "react-redux";

import Box from '../components/Box';

const AdminPage = ({
}) => {
  return (
    <Box className='w-95 flex ma3 pv3 ph4' style={{ background: "#f0f0f0" }}>
      <div className='flex flex-column'>
        <h1 className='mv2 mh3 sans-serif f4 fw4 greenmod'>Administration</h1>
        <div className='mt3 mh3 san-serif f5'>Here, we assume that we operate administrative tasks.</div>
        <div className='mb3 mh3 san-serif f5'>For example, deleting intents, changing the market price, and recovering user passwords.</div>
      </div>
    </Box>
  );
}

const mapStateToProps = state => ({
});

export default connect(mapStateToProps)(AdminPage);
